// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.45rem 0rem;
  margin-bottom: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.custom-breadcrumb-item {
  color: #dbdee0;
}
.custom-breadcrumb-item.active {
  color: #ffffff;
}
.custom-breadcrumb-item + .custom-breadcrumb-item {
  padding-left: 2.5rem;
  position: relative;
}
.custom-breadcrumb-item + .custom-breadcrumb-item:before {
  display: block;
  position: absolute;
  padding-right: 0.5rem;
  color: #ffffff;
  left: 20px;
  top: 30px;
  content: "\\f178";
  font-family: "Font Awesome 5 Pro";
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
.custom-breadcrumb-item a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/top_header/_breadcrumb.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;AACI;EACI,cAAA;AACR;AAEI;EACI,oBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AAAZ;AAII;EACI,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,wBAAA;AAFR","sourcesContent":[".custom-breadcrumb {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0.45rem 0rem;\n    margin-bottom: 0;\n    list-style: none;\n    border-radius: 0.25rem;\n}\n\n.custom-breadcrumb-item {\n    color: #dbdee0;\n\n    &.active {\n        color: #ffffff;\n    }\n\n    +.custom-breadcrumb-item {\n        padding-left: 2.5rem;\n        position: relative;\n\n        &:before {\n            display: block;\n            position: absolute;\n            padding-right: .5rem;\n            color: #ffffff;\n            left: 20px;\n            top: 30px;\n            content: \"\\f178\";\n            font-family: \"Font Awesome 5 Pro\";\n            font-weight: 300;\n            -webkit-font-smoothing: antialiased;\n            display: inline-block;\n            font-style: normal;\n            font-variant: normal;\n            text-rendering: auto;\n            line-height: 1;\n        }\n    }\n\n    a {\n        color: #007bff;\n        text-decoration: none;\n        background-color: transparent;\n        outline: none !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
